'use strict'

module.exports = ['$resource', function ($resource) {

    let Broadcast = $resource('/broadcasts/:id',
        {
            id: '@id'
        },
        {
            'save': { method: 'POST' },
            'update': { method: 'PATCH' }
        }
    )

    var save = Broadcast.save

    // Required for "easy" .save in controllers
    Broadcast.save = function (...args) {

        if (args[0].id) {
            this.update.apply(this, args)
        } else {
            save.apply(this, args)
        }
    }

    return Broadcast
}]
